import { format, isValid, parseISO } from 'date-fns'

import { nomeDiaSemana, rotuloSemValor } from './agrupamentoUi'

// Formatação só da prévia: o CSV leva o valor cru, do jeito que o banco devolveu.
export function formatarCelula(valor, tipo) {
    if (valor === null || valor === undefined || valor === '') {
        return '—'
    }

    if (tipo === 'data') {
        const data = typeof valor === 'string' ? parseISO(valor) : new Date(valor)
        if (isValid(data)) {
            // Data sem hora (AAAA-MM-DD, o formato do agrupamento por dia) não mostra 00:00.
            const semHora = typeof valor === 'string' && valor.length === 10
            return format(data, semHora ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm')
        }
    }

    // Nº de pedido, código de loja/cliente e ano não levam ponto de milhar.
    if (tipo === 'codigo') {
        return String(valor)
    }

    if (tipo === 'dinheiro' && Number.isFinite(Number(valor))) {
        return Number(valor).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    }

    if (tipo === 'numero' && Number.isFinite(Number(valor))) {
        return Number(valor).toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    }

    return String(valor)
}

// Célula de uma coluna que o relatório agrupou: o grupo vazio é um grupo de
// verdade ("Sem cliente"), não um travessão, e o dia da semana sai como no gráfico.
export function formatarCelulaDoGrupo(valor, coluna) {
    if (valor === null || valor === undefined || valor === '') {
        return rotuloSemValor(coluna)
    }

    if (coluna?.nome === 'diaSemana') {
        const dia = nomeDiaSemana(valor)
        if (dia) {
            return dia
        }
    }

    return formatarCelula(valor, coluna?.tipo)
}
